export default __webpack_public_path__ + "static/media/EmailIcon.8a5c1901.svg";